import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import translations from './translations'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: translations,
    debug: false,
    lng: 'sk',
    fallbackLng: ['sk', 'en'],
    whitelist: ['sk', 'en'],
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
